<template>
  <v-container grid-list-lg fluid class="ma-2">
    <v-layout row wrap>
      <v-flex xs12 class="cst-switch-bc">
        <v-switch
          class="cst-switch"
          v-model="status"
          label="Enable Dashboard"
          color="primary"
          @change="toggle"
          hide-details
        ></v-switch>
        <v-btn color="primary" @click="reload" v-if="status">
          Refresh Dashboard
        </v-btn>
      </v-flex>
      <template v-if="status">
        <v-flex xs12 md6 lg4 v-for="a in menu" :key="a.title" class="pa-2 px-3" @click="route(a)">
          <v-card :color="a.color" class="cst-card" dark>
            <v-flex xs12 class="center">
              <v-layout row wrap class="inner" v-if="a.loaded">
                <v-flex xs12 class="px-4">
                  <h3>{{a.value}}</h3>
                  <p class="ma-0">{{a.title}}</p>
                </v-flex>
                <div class="icon-bc">
                  <v-icon large>{{a.icon}}</v-icon>
                </div>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs12 class="center">
                  <div class="spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 class="cst-footer">
              More Info
              <v-icon small class="mx-2">play_circle_filled</v-icon>
            </v-flex>
          </v-card>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>
<script>
import Vuex from 'vuex'

const DashboardStore = Vuex.createNamespacedHelpers('DashBoard')
const dialogsStore = Vuex.createNamespacedHelpers('Dialogs')
export default {
  name: 'Dashboard',
  data () {
    return {
      title: 'Dashboard',
      status: true,
      menu: [
        {
          title: 'Drafted Request',
          icon: 'assignment',
          color: 'success',
          value: 0,
          loaded: false,
          to: {name: 'business-trip-request-list', params: {filter: 1}}
        },
        {
          title: 'Waiting Approval Request',
          icon: 'person_outline',
          color: 'success',
          value: 0,
          loaded: false,
          to: {name: 'business-trip-request-list', params: {filter: 2}}
        },
        {
          title: 'Waiting Release Funds',
          icon: 'monetization_on',
          color: 'warning',
          value: 0,
          loaded: false,
          to: {name: 'business-trip-funds-release'}
        },
        {
          title: 'Waiting Realization',
          icon: 'help_outline',
          color: 'purple darken-3',
          value: 0,
          loaded: false,
          to: {name: 'business-trip-realization-select-sppd'}
        },
        {
          title: 'Drafted Realization',
          icon: 'assignment',
          color: 'primary',
          value: 0,
          loaded: false,
          to: {name: 'business-trip-realization-list', params: {filter: 1}}
        },
        {
          title: 'Waiting Approval Realization',
          icon: 'person_outline',
          color: 'primary',
          value: 0,
          loaded: false,
          to: {name: 'business-trip-realization-list', params: {filter: 2}}
        }
      ]
    }
  },
  methods: {
    ...DashboardStore.mapActions({
      getDraftedRealization: 'getDraftedRealization',
      getDraftedRequest: 'getDraftedRequest',
      getWaitingApprovalRealization: 'getWaitingApprovalRealization',
      getWaitingApprovalRequest: 'getWaitingApprovalRequest',
      getWaitingRealization: 'getWaitingRealization',
      getWaitingReleaseFunds: 'getWaitingReleaseFunds',
      getToggleDashboard: 'getToggleDashboard'
    }),
    ...dialogsStore.mapActions({
      showAlert: 'showAlert'
    }),
    toggle () {
      this.getToggleDashboard({vueinstance: this}).then(() => {
        if (this.status && !this.menu[0].loaded) {
          this.reload()
        }
      })
    },
    _setupToolbar () {
      this.$store.dispatch('setTitle', {title: this.title})
      this.$store.dispatch('Action/setActions', this.actions)
    },
    route (a) {
      if (a.value === 0 || a.value === '0' || a.loaded === false) {
        this.showAlert({title: 'Error', message: 'Data not Found'})
      } else if (a.title === 'Waiting Release Funds') {
        this.$backend.businessTripRequestEmployee.getUnreleaseBtRequestFundsUsingGET({
          page: 0,
          impokey: '',
          empkey: '',
          size: 10
        }).then(res => {
          this.$router.push(a.to)
        }).catch(err => {
          this.$error(err)
        })
      } else {
        this.$router.push(a.to)
      }
    },
    reload () {
      this.menu.map((obj) => { obj.loaded = false })
      this.getDraftedRequest({vueinstance: this}).then(res => {
        this.menu[0].value = res.value
        this.menu[0].loaded = true
      })
      this.getWaitingApprovalRequest({vueinstance: this}).then(res => {
        this.menu[1].value = res.value
        this.menu[1].loaded = true
      })
      this.getWaitingReleaseFunds({vueinstance: this}).then(res => {
        this.menu[2].value = res.value
        this.menu[2].loaded = true
      })
      this.getWaitingRealization({vueinstance: this}).then(res => {
        this.menu[3].value = res.value
        this.menu[3].loaded = true
      })
      this.getDraftedRealization({vueinstance: this}).then(res => {
        this.menu[4].value = res.value
        this.menu[4].loaded = true
      })
      this.getWaitingApprovalRealization({vueinstance: this}).then(res => {
        this.menu[5].value = res.value
        this.menu[5].loaded = true
      })
    }
  },
  mounted () {
    this.$store.dispatch('Menu/list', {vueinstance: this})
      .then(res => {
        this.status = res.enableDashboard
        if (this.status) {
          this.reload()
        }
      })
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm._setupToolbar()
    })
  }
}
</script>

<style scoped>
.cst-switch-bc{
  display: flex;
  align-items: center;
}
.cst-footer{
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.2);
  font-weight: bold;
  height: 30px;
  padding: 0 !important;
}
.icon-bc{
  position: absolute;
  top: 10px;
  right: 20px;
}
.icon-bc i {
  font-size: 60px !important;
  color: rgba(0, 0, 0, 0.21)
}
.inner{
  position: relative;
}
.cst-card{
  cursor: pointer;
  height: 150px !important;
}
.center{
  height: 120px !important;
  position: relative;
  display: flex !important;
  align-items: center;
}
.cst-card h3{
  font-size: 33px;
}
.cst-card p{
  font-size: 15px;
}
.cst-card:hover .icon-bc i {
  font-size: 75px !important;
}
/* spinner css */
.spinner {
  margin: 30px auto 0;
  width: 70px;
  text-align: center;
}

.spinner > div {
  width: 18px;
  height: 18px;
  background-color: #FFF;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1s infinite ease-in-out both;
  animation: sk-bouncedelay 1s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue